import PropTypes from 'prop-types'
import BottomNav from './_components/BottomNav'
import NavigationMenu from './_components/NavigationMenu'
import NavigationRail from './_components/NavigationRail'
import WalkthroughContainer from './_components/WalkthroughContainer'
import { NAVIGATION_TYPES } from 'utils/constants'

const Navigation = ({ type, isOpen, onClose }) => {
  if (type === NAVIGATION_TYPES.BOTTOM) {
    return (
      <WalkthroughContainer portalId='bottom-menu'>
        <BottomNav />
      </WalkthroughContainer>
    )
  }
  if (type === NAVIGATION_TYPES.MENU) {
    return <NavigationMenu isOpen={isOpen} onClose={onClose} />
  }
  return (
    <WalkthroughContainer portalId='navrail-menu'>
      <NavigationRail />
    </WalkthroughContainer>
  )
}

Navigation.defaultProps = {
  isOpen: false,
  onClose: null,
  type: NAVIGATION_TYPES.RAIL,
}

Navigation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.oneOf([
    NAVIGATION_TYPES.RAIL,
    NAVIGATION_TYPES.MENU,
    NAVIGATION_TYPES.BOTTOM,
  ]),
}
export default Navigation
